import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
//import ItemSucursalVentaDiaria from './ItemSucursalVentaDiaria';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { useRef } from 'react';
const server = process.env.REACT_APP_SERVER;

function ReportePuestasDePollo() {
    const [regional, setRegional] = useState(JSON.parse(localStorage.getItem('info')).ID_REGIONAL_ACTUAL);
    const [idEmpleado, setIdEmpleado] = useState(0);
    const [fecha, setFecha] = useState('');
    const [actualizar, setActualizar] = useState(false);
    const [sucursal, setSucursales] = useState([]);
    const [idSucursal, setIdSucursal] = useState(0);
    const [datos, setDatos] = useState([]);
    const tableRef = useRef(null);

    useEffect(() => {
        var fech = new Date()
        fech.setDate(fech.getDate() - 1);
        var mes = parseInt(fech.getMonth()) + 1;
        mes = mes < 10 ? `0${mes}` : mes
        var dia = fech.getDate();
        dia = dia < 10 ? `0${dia}` : dia
        setFecha(fech.getFullYear()+'-'+mes+'-'+dia)
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    console.log(data.ok)
                    setSucursales(data.ok);
                    if (data.ok.length > 0) {
                        setIdSucursal(data.ok[0].ID_SUCURSAL);
                    }
                }

            })
            .catch(error => MsgUtils.msgError(error));
    }, [])

    useEffect(() => {
        if(idSucursal != 0){
            var info = JSON.parse(localStorage.getItem('info'));
            setIdEmpleado(info.ID_EMPLEADO);
            const sucursalSeleccionada = sucursal.find(
                item => item.ID_SUCURSAL === Number(idSucursal)
            );
            fetch(`${server}/reporte/getPuestaDePolloSucursal`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional,
                    ...sucursalSeleccionada,
                    'idEmpleado': info.ID_EMPLEADO,
                    fecha
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } 
                    else{
                        const datosFormateados = data.ok.map(item => ({
                            idFreidora: item[0],
                            fechaInicio: item[1],
                            tiempoProceso: item[2],
                            cantidad1: item[3],
                            cantidad2: item[4],
                            cantidad4: item[5],
                            cantidad5: item[6]
                        }));
                        setDatos(datosFormateados);                
                    }
                })
                .catch(error => MsgUtils.msgError(error));
            }
    },[idSucursal,fecha])

    return (
        <>
            <div className='bg-dark bg-gradient container-fluid py-1'>
                <div className='row row-cols gx-1'>
                    <div className='col' style={{ maxWidth: '160px', minWidth: '160px' }}>
                        <div className="input-group input-group-sm">
                            <span className="text-light mx-1 my-auto" >Fecha</span>
                            <input type="date" className="form-control" placeholder="Username" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '120px', minWidth: '120px' }}>
                        <button className='btn btn-sm btn-success w-100' onClick={() => setActualizar(!actualizar)}>
                            <i className="fa-solid fa-magnifying-glass"></i> Cargar</button>
                    </div>
                    <div className='col' style={{ maxWidth: '160px', minWidth: '160px' }}>
                        <div className="input-group input-group-sm" style={{ width: '190px' }}>
                            <span className="text-light mx-1 my-auto" >FILTRAR</span>
                            <select className="form-select form-select-sm" value={idSucursal} onChange={(e) => setIdSucursal(e.target.value)}>
                                {sucursal.map((item, index) => {
                                    return (
                                        <option value={parseInt(item.ID_SUCURSAL)} key={index}>{item.SUCURSAL}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{
                            maxWidth: '100px',
                            minWidth: '100px',
                            marginLeft: '40px'
                        }}>
                            <DownloadTableExcel
                                filename={`PuestasPollo_${fecha}`}
                                sheet="Reporte"
                                currentTableRef={tableRef.current}
                            >
                                <button className='btn btn-sm btn-success w-100'>
                                    <i className="fa-solid fa-file-excel"></i>
                                    Excel
                                </button>
                            </DownloadTableExcel>
                    </div>
                </div >
            </div >
            <div className='container-fluid mt-2'>
                <table ref={tableRef} className='table table-sm table-bordered table-dark'>
                    <thead>
                        <tr>
                            <th>Freidora</th>
                            <th>Fecha Inicio</th>
                            <th>Tiempo</th>
                            <th>Alas</th>
                            <th>Piernas</th>
                            <th>Pipocas</th>
                            <th>Media Pipoca</th>
                        </tr>
                    </thead>
                    <tbody>
                        {datos.map((item, index) => (
                            <tr key={index}>
                                <td>{item.idFreidora}</td>
                                <td> {new Date(item.fechaInicio).toLocaleString('es-BO')}</td>
                                <td>{item.tiempoProceso}</td>
                                <td>{item.cantidad1}</td>
                                <td>{item.cantidad2}</td>
                                <td>{item.cantidad4}</td>
                                <td>{item.cantidad5}</td>
                            </tr>
                        ))}

                    </tbody>

                </table>

            </div>
        </>
    )
}

export default ReportePuestasDePollo